import { CalculateConsent } from "@app/calculate/calculate/models/consent.model";

export class InsuranceStartDateModel {
  startDate: Date;
  promotionalCode: string;
  largeFamilyCardNumber: number;
  vitayCardNumber: number;
  selectedConsents: CalculateConsent[];
  allConsents: CalculateConsent[];
  aiPredator: string;
}
